import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  TextField,
  Button,
  Typography,
  IconButton,
  Box,
  InputAdornment,
  useTheme
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";

import useMediaQuery from "@mui/material/useMediaQuery";
import { motion } from "framer-motion";
import { trackLead } from "../../../utils/fbConversion";

const inputStyle = {
  background: "#ffffff",
  borderRadius: "12px",
  "& .MuiOutlinedInput-root": {
    borderRadius: "12px",
    boxShadow: "0 4px 14px rgba(0,0,0,0.05)",
    "& fieldset": { borderColor: "#e4e4e7" },
    "&:hover fieldset": { borderColor: "#b9b9c3" },
    "&.Mui-focused fieldset": { borderColor: "#5e17eb" },
  },
};

export default function ReferralPopUpV2({ open, setOpen }) {
  const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  
    const [gclid, setGclid] = useState("");
    const [formError, setFormError] = useState("");
  
    const [formValues, setFormValues] = useState({
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      refereeEmail: "",
      website: window.location.href.slice(0, 250),
      description: window.location.href.includes("full-stack-web-development")
        ? "Full Stack Web Development"
        : window.location.href.includes("devops-and-cloud-training-online")
        ? "DevOps and Cloud with GenAI Master Program"
        : "DevOps and Cloud with GenAI Job Ready Program",
    });
  
    const [errors, setErrors] = useState({
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
    });
  
    const validateFirstName = (v) => (!v ? "First name is required" : "");
    const validateLastName = (v) => (!v ? "Last name is required" : "");
    const validateEmail = (v) =>
      !v
        ? "Email is required"
        : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)
        ? ""
        : "Invalid email address";
    const validatePhone = (v) =>
      !v
        ? "Phone number is required"
        : /^\d{10}$/.test(v)
        ? ""
        : "Phone number must be 10 digits";
  
    const handleChange = (e, field) => {
      const value = e.target.value;
  
      setFormValues({ ...formValues, [field]: value });
  
      let error = "";
      if (field === "firstName") error = validateFirstName(value);
      if (field === "lastName") error = validateLastName(value);
      if (field === "email") error = validateEmail(value);
      if (field === "phone") error = validatePhone(value);
  
      setErrors({ ...errors, [field]: error });
    };
  
    useEffect(() => {
      const urlGclid = new URLSearchParams(window.location.search).get("gclid");
      if (urlGclid) {
        localStorage.setItem("gclid", urlGclid);
        setGclid(urlGclid);
      } else {
        setGclid(localStorage.getItem("gclid"));
      }
    }, []);
  
    const handleFormSubmit = (e) => {
      const first = validateFirstName(formValues.firstName);
      const last = validateLastName(formValues.lastName);
      const email = validateEmail(formValues.email);
      const phone = validatePhone(formValues.phone);

      if (first || last || email || phone) {
        e.preventDefault();
        setErrors({ firstName: first, lastName: last, email, phone });
        setFormError(first || last || email || phone);
        return;
      }

      trackLead({
        contentName: "Refer and Earn",
        email: formValues.email,
        phone: formValues.phone,
        firstName: formValues.firstName,
        lastName: formValues.lastName,
      });
    };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      fullWidth
      maxWidth="md"
      PaperProps={{ sx: { borderRadius: "18px", overflow: "hidden" } }}
    >
      <IconButton
        aria-label="Close Referral Form"
        onClick={() => setOpen(false)}
        sx={{ position: "absolute", right: 14, top: 14, zIndex: 10 }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ p: 0 }}>
        <Box display="flex" flexDirection={isMobile ? "column" : "row"}>

          {/* IMAGE */}
          {!isMobile && (
            <Box flex={1} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <img
                loading="lazy"
                src={"https://img.freepik.com/free-vector/brand-loyalty-concept-illustration_114360-11553.jpg?t=st=1730617377~exp=1730620977~hmac=031f267034ca94db86bc1de4ba68b7378a0324994a58c95b64e88b7c9f446f58&w=740"}
                alt="Refer Offer"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </Box>
          )}

          {/* FORM */}
          <Box flex={1} sx={{ p: { xs: 3, md: 4 } }}>
            <motion.div
              initial={{ opacity: 0, y: 25 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.35 }}
            >
              <Typography variant="h5" fontWeight={700} mb={1}>
                Refer a Friend
              </Typography>

              <Typography color="text.secondary" mb={3}>
                Share their details — we’ll call them shortly.
              </Typography>

              {/* ZOHO FORM */}
              <Box
                component="form"
                id="webform774394000000383041"
                name="WebToLeads774394000000383041"
                action="https://crm.zoho.in/crm/WebToLeadForm"
                method="POST"
                onSubmit={handleFormSubmit}
                sx={{ display: "grid", gap: "14px" }}
              >
                <input
                  type="hidden"
                  name="xnQsjsdp"
                  defaultValue="f07b7a4b6659358455389930012286a3410cba7954538e33231ff7e9aad48945"
                />
                <input
                  type="hidden"
                  name="xmIwtLD"
                  defaultValue="1552053f479e3fe0362110db6ab472ae2e1d5b36f8cbb945d426e6c1adc7065baf9e5abb9ac2a5267203e02d89eda0ac"
                />
                <input type="hidden" name="actionType" defaultValue="TGVhZHM=" />
                <input
                  type="hidden"
                  name="returnURL"
                  defaultValue="https://paperlive.in/thankyou"
                />
                <input type="hidden" id="zc_gad" name="zc_gad" value={gclid} />
                <input type="hidden" id="Website" name="Website" value={formValues.website} />
                <input type="hidden" id="Description" name="Description" value={formValues.description} />

                <TextField
                  label="Referee Email"
                  name="refereeEmail"
                  value={formValues.refereeEmail}
                  onChange={(e) => handleChange(e, "refereeEmail")}
                  error={!!errors.refereeEmail}
                  sx={inputStyle}
                  InputProps={{ startAdornment: <InputAdornment position="start"><EmailIcon /></InputAdornment> }}
                />

                <TextField
                  label="First Name"
                  id="First_Name"
                  name="First Name"
                  value={formValues.firstName}
                  onChange={(e) => handleChange(e, "firstName")}
                  error={!!errors.firstName}
                  sx={inputStyle}
                  InputProps={{ startAdornment: <InputAdornment position="start"><AssignmentIndIcon /></InputAdornment> }}
                />

                <TextField
                  label="Last Name"
                  id="Last_Name"
                  name="Last Name"
                  value={formValues.lastName}
                  onChange={(e) => handleChange(e, "lastName")}
                  error={!!errors.lastName}
                  sx={inputStyle}
                  InputProps={{ startAdornment: <InputAdornment position="start"><AssignmentIndIcon /></InputAdornment> }}
                />

                <TextField
                  label="Email"
                  id="Email"
                  name="Email"
                  value={formValues.email}
                  onChange={(e) => handleChange(e, "email")}
                  error={!!errors.email}
                  sx={inputStyle}
                  InputProps={{ startAdornment: <InputAdornment position="start"><EmailIcon /></InputAdornment> }}
                />

                <TextField
                  label="Phone Number"
                  id="Phone"
                  name="Phone"
                  value={formValues.phone}
                  onChange={(e) => handleChange(e, "phone")}
                  error={!!errors.phone}
                  sx={inputStyle}
                  InputProps={{ startAdornment: <InputAdornment position="start"><PhoneIphoneIcon /></InputAdornment> }}
                />

                {/* <Typography color="error">{formError}</Typography> */}

                <Button
                  aria-label="Submit Referral Form"
                  type="submit"
                  variant="contained"
                  fullWidth
                  sx={{
                    mt: 1,
                    borderRadius: "12px",
                    fontWeight: 700,
                    height: 45,
                    textTransform: "none",
                    background: "#5e17eb",
                    ":hover": { background: "#4d13c6" },
                  }}
                >
                  Submit Referral
                </Button>
              </Box>
            </motion.div>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}